import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { Reveal } from "./Reveal";

const STATS = [
    { value: 6, label: "Modules", sub: "Desk booking, floor plans, transport, people, workflows, and AI", testid: "stat-tile-modules" },
    { value: 4, label: "Office Floors", sub: "Floors 2, 3, 4, and 6 mapped live", testid: "stat-tile-floors" },
    { value: 1, label: "Platform", sub: "Every request, approval, and answer in one place", testid: "stat-tile-platform" },
];

function Counter({ value }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const reduce = useReducedMotion();
    const [display, setDisplay] = useState(0);

    useEffect(() => {
        if (!inView) return;
        if (reduce) { setDisplay(value); return; }
        const controls = animate(0, value, {
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
            onUpdate: (v) => setDisplay(Math.round(v)),
        });
        return () => controls.stop();
    }, [inView, value, reduce]);

    return <span ref={ref}>{display}</span>;
}

export function Stats() {
    return (
        <section data-testid="stats-section" className="relative bg-[var(--paper)] border-y border-slate-200/80">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-6">
                    {STATS.map((s, i) => (
                        <Reveal key={s.label} delay={i * 0.1}>
                            <div
                                data-testid={s.testid}
                                className="relative pl-5 border-l-2 border-[var(--accent)]/70"
                            >
                                <div className="font-display font-extrabold text-5xl sm:text-6xl tracking-tight text-[var(--ink)] tabular-nums">
                                    <Counter value={s.value} />
                                </div>
                                <div className="mt-2 font-display font-semibold text-lg text-[var(--ink)]">{s.label}</div>
                                <p className="mt-1 text-sm leading-relaxed text-[var(--ink-3)] max-w-xs">{s.sub}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
